import React from 'react'

export const HelpContent = (props) => {
  const string = props.stringToRet;

  return (
    <>
      {(string === 'help1_room1') && (
        <>
        <p>Hai notato qualche somiglianza tra le sagome nel programma di disegno e gli oggetti nelle foto sul
        desktop del pc? Hai provato a prendere nota dei numeri corrispondenti agli oggetti disegnati?</p>
        </>
      )}
      {(string === 'help2_room1') && (
        <p>Hai cliccato sul desktop del pc sul tasto “fatti aiutare dal codice ASCII”? Nel sito che ti si è aperto hai inserito le coppie di numeri che hai trovato?</p>
      )}
      {(string === 'help3_room1') && (
        <p>Hai cercato tra le foto degli oggetti appese in bacheca l’oggetto il cui nome corrisponde al risultato del codice ASCII? Che numero di inventario ha?</p>
      )}


      {(string === 'help0_room2') && (
        <>
          <p>Attenzione: puoi utilizzare quanti aiuti desideri, ma tieni presente che alla fine della partita gli aiuti sono convertiti in penalità:</p>
          <p>aiuto di tipo 1=1 penalità<br />
          aiuto di tipo 2=2 penalità<br />
          aiuto di tipo 3=3 penalità<br />
          Pensa bene a quanti aiuti vuoi utilizzare!</p>
        </>
      )}
      {(string === 'help1_room2') && (
        <p>La prima cosa da fare è cercare di risolvere l’enigma del telescopio. Hai notato che ci sono dei lampi luminosi
        prolungati e altri più brevi?
        Non ti ricorda un qualche tipo di codice? Prova a prendere nota dei lampi lunghi e lampi corti… SOS ti dice niente?</p>
      )}
      {(string === 'help2_room2') && (
        <p>Adesso che hai decifrato il codice Morse, devi usare gli altri due indizi. Hai aperto le Google Maps?<br />
        Hai identificato la cupola del telescopio di Brera aiutandoti con le due foto?<br />
        Adesso esplora la cupola a 360° cliccando sul visore.<br />
        Osservando bene la stanza, in che direzione punta il telescopio? Ti ricordi l’indizio per la password?</p>
      )}
      {(string === 'help3_room2') && (
        <p>Se hai notato, il telescopio all’interno della cupola punta in direzione NORD-EST (vedi le targhe color oro alle pareti N e E?). <br />
        Se guardi la cupola vista dall’alto nelle Google Maps (la cupola del telescopio è quella piccolina come puoi vedere nelle foto)
        qual è il museo più vicino in linea d’aria in direzione NORD-EST? Se non vedi alcuni nomi sulla mappa, prova a usare lo zoom</p>
      )}

      {(string === 'help4_room2') && (
        <p>L’indizio è un gioco di parole. Hai ingrandito la lettera di Napoleone? Hai osservato l’illustrazione?</p>
      )}
      {(string === 'help5_room2') && (
        <p>Hai notato che la Marianne ha un oggetto sul piede destro?</p>
      )}
      {(string === 'help6_room2') && (
        <p>Un piccolo sforzo in più…come si chiama quella specifica parte della spada? Prova a cercare su Google…</p>
      )}
      {(string === 'help7_room2') && (
        <p>L’indagine deve partire dalla filastrocca, andando per ordine.
        A cosa si allude con il termine capriccioso? Leggi la lettera di Elsa. <br/>
        «…abbastanza bene. Voi invece poveretti mi dicono che siete sottoposti a
        tutti i più capricciosi capricci di Giove!! Presto presto risponderò alla
        lettera dell'Emma che mi fece un grandissimo piacere. Intanto ti prego di
        dire tante cose affettuose a lei ed ai cugini a tutti i cari milanesi che
        sono stati così gentili con me. A te rinnovando infiniti auguri con vivo ricordo…»<br />
        Hai trovato il pianeta? Ti ricordi che i pianeti seguono un’orbita attorno
        al Sole e nel fare questo «transitano» all’interno delle costellazioni dello
        zodiaco?</p>
      )}
      {(string === 'help8_room2') && (
        <p>Come fare a sapere la costellazione in cui Giove transitava in «quei giorni»?
        Si allude al periodo in cui è stata scritta la lettera da Elsa,
        20 giugno 1908. <a href="https://heavens-above.com/skychart2.aspx" target="_blank">Vai sul sito</a> che trovi cliccando sul cellulare
        e inserisci la data 20 giugno 1908 (ricordati di premere il tasto aggiorna).
        Hai trovato Giove? In quale costellazione si trova? Se non è molto visibile, prova a cambiare le ore della giornata.</p>
      )}
      {(string === 'help9_room2') && (
        <p>Hai cliccato la collana sulla scrivania? Consulta il catalogo della Maison Schiaparelli.
        La password è il nome della collana che ha come segno zodiacale
        quello della costellazione in cui transita Giove il 20 giugno 1908.</p>
      )}



      {(string === 'help1_room3') && (
        <p>Partiamo dall’indizio…«Il nome che voglio, stampatelo bene in testa,
        è quello del Re dimezzato.». Guarda con attenzione la pagina di diario
        usando lo Zoom. C’è un gioco di parole con «re dimezzato».
        C’è un elemento sulla pagina di diario che è «dimezzato»?
        Anche «stampatelo in testa» è un indizio.
        C’è per caso una testa? Ha a che fare con la…stampa?</p>
      )}
      {(string === 'help2_room3') && (
        <p>Prova a cercare su Google le parole associate a quel francobollo.
        Ci sono scritte alcune cose. Si tratta per caso di una «testa» famosa?</p>
      )}
      {(string === 'help3_room3') && (
        <p>Hai cercato su Google parole come «francobollo 5 centesimi, poste italiane,
        1890»? Prova a filtrare i risultati con «immagini». Trovi per caso l’immagine
        del nostro francobollo? Leggi le informazioni associate.<br/>
        Attenzione a trovare il Re corretto, il nostro è proprio Vittorio Emanuele III!</p>
      )}
      {(string === 'help4_room3') && (
        <>
          <p>La password richiesta è formata da 4 coordinate geografiche.<br />
          Abbiamo a disposizione lo zoom di una porzione della mappa completa di Marte con coordinate.<br />
          Anche in questo caso bisogna partire dall’indizio. Le coordinate richieste corrispondono ad un punto preciso sulla mappa.</p>
          <p>Forza a caccia di luoghi marziani!</p>
        </>
      )}
      {(string === 'help5_room3') && (
        <p>Trova il punto di incontro tra i tre luoghi citati nell’indizio. O siete molto eruditi, oppure ricorrete ancora una volta a Google.<br />
        Provate a cercare il 14° re di Argo, il nome del dio del fuoco e la più alta catena montuosa dell’attica.<br />
        Fate attenzione perché Schiaparelli utilizza i nomi in latino o greco che differiscono un poco dalla versione in italiano moderno…</p>
      )}
      {(string === 'help6_room3') && (
        <p>Hai trovato i tre nomi sulla mappa di Marte? Guarda con attenzione, ci sono tre canali con questi nomi che terminano tutti all’interno di un unico quadrante.<br />
        Il «quadratino» è descritto da 4 coordinate: 2 per la latitudine, 2 per la longitudine. Inserisci sempre prima nei campi di input il numero più piccolo, poi quello più grande...</p>
      )}



      {(string === 'help1_room4') && (
        <p>Sei andato sul profilo Instagram della dott.ssa Hacker?
        Ti sei accorto che puoi fare «swipe» tra le immagini, una originale e
        l’altra con filtro? Guarda bene, l’uso del filtro non è l’unica cosa
        che cambia tra una immagine e la successiva…</p>
      )}
      {(string === 'help2_room4') && (
        <p>Hai guardato anche le minime differenze tra una immagine e la sua
        versione con filtro? Prova a prestare particolare attenzione alle scritte…</p>
      )}
      {(string === 'help3_room4') && (
        <p>Se metti insieme le tre lettere mancanti nelle foto con filtro in ordine
        così come le hai trovate nei 3 post, avrai la password (imu).</p>
      )}




      {(string === 'help4_room4') && (
        <p>Quella sequenza di 0 e 1 non ti ricorda qualcosa associato al computer?
        Hai provato a incollare la sequenza o parte di essa in google? Quali siti
        ti ha suggerito?</p>
      )}
      {(string === 'help5_room4') && (
        <p>Hai trovato un convertitore online da codice binario a testo?
        Hai notato che il risultato è una frase separata da punti?
        Si tratta in realtà di 4 frasi distinte che vanno ordinate dal numero
        1 al numero 4 dandogli un senso logico.</p>
      )}
      {(string === 'help6_room4') && (
        <p>Le azioni ripercorrono l’incidente in senso cronologico, quindi se il
        problema è stato causato dal computer, la prima azione è «computer di bordo
        in tilt», poi è stato sganciato il paracadute (se guardi attentamente l’ultima
        immagine del post di Instagram si vede proprio questa azione)
        «sgancio paracadute», poi sono stati accesi i retrorazzi e alla fine,
        purtroppo, il lander si è schiantato al suolo (crash).</p>
      )}






      {(string === 'help1_room5') && (
        <p>E’ necessario rispondere alla domanda «le mappe di Schiaparelli negli anni ‘60 del XX secolo vennero utilizzate per pianificare le prime….?». L’unico modo che abbiamo è ascoltare il podcast per sapere la risposta. Possiamo o ascoltarlo tutto, ma 17 minuti probabilmente giunti a questo punto non li avrete, oppure trovare una scorciatoia.
L’indizio dice «I due gemelli non sono uguali stampati, la pur minima differenza ti dirà dove ascoltare e cosa rispondere».
A cosa si riferisce con «due gemelli»? Prova a osservare attentamente l’immagine della domenica del corriere e la stessa immagine stampata sull’allestimento nella sezione Spazio del museo.</p>
      )}
      {(string === 'help2_room5') && (
        <p>Se hai zoomato l’immagine della Domenica del Corriere ti sarai accorto che in corrispondenza di alcuni dettagli compaiono dei numeri. Non sono forse l’indicazione di minuti e secondi?
Potrebbero darci un indizio su quale sia il punto esatto del podcast in cui trovare la risposta?
Resto il dubbio che sono più di uno…forse un dettaglio diverso tra la copertina e la parete al Museo ci darà l’indicazione su quale minutaggio considerare? </p>
      )}
      {(string === 'help3_room5') && (
        <p>Hai provato a guardare con attenzione la testa di Giovanni Virginio Schiaparelli? L’hai confrontata con la riproduzione sulla parete del museo tramite le mappe? Hai notato qualche differenza?
Nel podcast, vai al minutaggio riportato in corrispondenza del dettaglio differente e ascolta per alcuni secondi. La risposta alla domanda verrà data direttamente dal curatore della Sezione Spazio del Museo! </p>
      )}

      {(string === 'help1_room6') && (
        <p>Il primo indizio che dobbiamo utilizzare è «Mentre studiavo il Rover «Perseverance» mi sono accorta di uno strano simbolo presente sul «trapano di carotaggio» che serve per estrarre dal suolo campioni di rocce.». Sei sul sito Online 3D Viewer che mostra il modello di Perseverance in 3D? Osserva il rover da più angolazioni.<br />
        <strong>Su windows</strong>: tenendo premuto il tasto sinistro del mouse puoi ruotare il modello di 360°, tenendo premuto il tasto destro (oppure tasto sinistro + maiusc) puoi invece spostarlo a tuo piacimento nella scena e ruotando la rotellina del mouse puoi fare zoom in e zoom out (oppure tasto sinistro + ctrl). <br />
        <strong>Su Mac</strong>: tenendo premuto il tasto sinistro del mouse puoi ruotare il modello di 360°, tenendo premuto il tasto sinistro + shift/maiuscole puoi invece spostarlo a tuo piacimento nella scena e infine ruotando la rotellina del mouse (o scrollando con il trackpad) puoi fare zoom in e zoom out.<br />
        Qual è il trapano di carotaggio? Cerca il braccio robotico. Per un indizio, apri lo schema sulla console della NASA nella scena con Margherita.</p>
      )}
      {(string === 'help2_room6') && (
        <p>Se hai trovato il trapano di carotaggio avrai notato che ruotandolo nelle diverse angolazioni e zoomando, sul lato superiore sono presenti alcuni «strani» simboli che assomigliano a QR CODE, fatti di tanti quadratini bianchi e neri.<br />
        Come fare a capire quale QR CODE utilizzare? Hai provato a confrontare la forma del componente visto dall’alto con lo schema che si apre cliccando in basso a destra sul pannello nella sala in cui si trova Margherita?<br />
        Il quadratino verde ci dà una mano.</p>
      )}
      {(string === 'help3_room6') && (
        <p>Ora che hai identificato il quadratino corretto (all’estrema sinistra guardando il trapano dall’alto in direzione di marcia del rover) prova a ingrandirlo al massimo possibile (zoom in).<br />
        Noti qualche possibile somiglianza con la griglia che contiene le lettere che visualizzi cliccando in basso a sinistra sul pannello nella sala in cui si trova Margherita?<br />
        Hai provato a contare di quanti quadratini è fatto il simbolo? E se provassi a considerare sulla griglia con le lettere solo le lettere che corrispondono ai quadratini bianchi del simbolo, partendo da sinistra in alto e scendendo riga per riga verso il basso?<br />
        Queste lettere significano qualcosa?</p>
      )}


    </>
  )
}
